/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';

import Section from 'solis/claude/primitive/section';

import ZoneRuleType from 'solis/claude/action/enum/zone.rule.type';


const RULE_LABELS =
{
  [ZoneRuleType.Incentive]: 'Incentive',
  [ZoneRuleType.Penalty]:   'Penalty',
};


export default ({ zone }) =>
{
  const rule = zone.cass.rule;

  return (
    <Card>
      <Section label = {'Zone ' + zone.getAbsoluteHex()}>

        <Text.Note>{'Value: ' + zone.cass.value}</Text.Note>

        {rule !== null && <Text.Note>{'Rule: ' + RULE_LABELS[rule.type] + ' ' + rule.value}</Text.Note>}

      </Section>
    </Card>
  );
};
